import { createIsomorphicFn } from '@tanstack/react-start';
import { defaultShouldDehydrateQuery, QueryClient } from '@tanstack/react-query';
import { default as superjson } from 'superjson';

export function makeQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30 * 1000,
      },
      dehydrate: {
        serializeData: superjson.serialize,
        shouldDehydrateQuery: (query) => defaultShouldDehydrateQuery(query) || query.state.status === 'pending',
      },
      hydrate: {
        deserializeData: superjson.deserialize,
      },
    },
  });
}

const testHosts = new Set(['render-test.freefit.tech', 'test.freefit.tech']);

export function getBrowserApiHost(host: string | undefined, development: boolean, location: Pick<Location, 'origin' | 'host'>) {
  if (host) return host.replace(/\/$/, '');
  if (development) {
    const url = new URL(location.origin);
    url.port = '7001';
    return url.origin;
  }
  return testHosts.has(location.host) ? 'https://api-test.freefit.tech' : 'https://api.freefit.tech';
}

export const getApiHost = createIsomorphicFn()
  .server(() => {
    const host = process.env.VITE_API_HOST;
    if (host) return host.replace(/\/$/, '');
    if (process.env.NODE_ENV === 'development') return 'http://localhost:7001';
    const port = process.env.NODE_ENV === 'test' ? 7001 : 8001;
    return `http://172.17.0.1:${port}`;
  })
  .client(() => getBrowserApiHost(import.meta.env.VITE_API_HOST, import.meta.env.DEV, window.location));

export function getTrpcEndpoint() {
  return `${getApiHost()}/trpc/v2`;
}
